import InvoiceContainer from './invoice-container';

export default InvoiceContainer;
